
	frappe.templates['sidebar'] = `<div class="body-sidebar-container {%= expanded ? 'expanded' : ''%}">
	<div class="body-sidebar-placeholder"></div>
		<div class="body-sidebar">
			<div class="standard-items-sections">
				<div class="dropdown-notifications hidden">
					<div class="notifications-list" role="menu">
						<div class="notification-list-header">
							<div class="header-items"></div>
							<div class="header-actions"></div>
						</div>
						<div class="notification-list-body">
							<div class="panel-notifications"></div>
							<div class="panel-events"></div>
							<div class="panel-changelog-feed"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="body-sidebar-top">
				<div class="sidebar-items">
				</div>
				<div class="edit-mode standard-sidebar-item hidden" data-name="add-sidebar-item" >
					<a
						class="item-anchor"
					>
						<span class="sidebar-item-icon text-ink-gray-7">
							{%= frappe.utils.icon("add" , "sm", "", "", "text-ink-gray-7 current-color", true)%}
						</span>
						<span class="sidebar-item-label">Add Sidebar Item<span>
					</a>
				</div>
			</div>
			<div class="body-sidebar-cards"></div>
			<div class="body-sidebar-bottom">
				<div class="edit-mode bottom-edit-controls hidden">
					<button class="btn-outline btn-sm discard-button">
						Discard
					</button>
					<button class="btn btn-primary btn-sm save-sidebar">
						Save
					</button>
				</div>
				<div class="promotional-banners"></div>
				<p>
					<a class="onboarding-sidebar px-2">
						{%= frappe.utils.icon("user-check" , "sm", "", "", "text-ink-gray-7 current-color", true)%}
						 <span> {%= __("Getting Started") %} </span>
					</a>
				</p>
				<div class="nav-item dropdown dropdown-navbar-user dropdown-mobile mt-3">
					<a
						class="align-center btn-reset flex nav-link sidebar-user-button"
						style="width: 100%; min-height: 40px;"
						onclick="return frappe.ui.toolbar.route_to_user()"
						aria-label="{{ __("User Menu") }}"
					>
						<div> {{ avatar }} </div>
						<div class="avatar-name-email text-small overflow-hidden w-75" style="margin-left: 8px;">
							<span class="d-block text-truncate">
								{{ frappe.session.user_fullname }}
							</span>
							<span class="d-block text-secondary text-truncate" style="margin-top: -1px;">
								{{ frappe.session.user_email }}
							</span>
						</div>

					</a>
				</div>
			</div>
			<button
				class="collapse-sidebar-link sidebar-toggle-btn"
				aria-label="{%= __('Toggle Sidebar') %}"
				data-placement="right"
			>
				{%= frappe.utils.icon(expanded ? "chevron-left" : "chevron-right", "sm", "", "", "", true) %}
			</button>
			<div class="sidebar-resize-handle"></div>
		</div>
		<div class="overlay" style="z-index: 1021;"></div>
		<div class="user-onboarding"></div>
	</div>
</div>
`;
